import { Filter } from '@anytag/shared-molecules';
import { useCampaignInfluencersContext } from '../CampaignInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const CampaignInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage } = useCampaignInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} />
    </Filter.Provider>
  );
};
